import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=219d4146&scoped=true&"
import script from "./CookiePolicy.vue?vue&type=script&lang=js&"
export * from "./CookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=219d4146&lang=scss&scoped=true&"
import style1 from "./CookiePolicy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219d4146",
  null
  
)

export default component.exports